import type { FC, PropsWithChildren } from 'react';
import { classNames } from '@/shared/lib/classNames';
import { Typography } from '../../Typography';
import cls from './Cell.module.scss';

type Props = {
    className?: string;
    error?: null | string;
    errorClassName?: string;
};

export const Cell: FC<PropsWithChildren<Props>> = ({ children, className, errorClassName, error }) => {
    return (
        <div className={classNames(cls.container, {}, [className])}>
            {children}
            {error && (
                <Typography className={classNames(cls.error, {}, [errorClassName])} as="span" variant="error">
                    {error}
                </Typography>
            )}
        </div>
    );
};
